<template>
    <div class="d-area-loader" />
</template>

<script lang="ts">
export default { name: 'DAreaLoader' };
</script>
